export class RecorderError extends Error {
  constructor(msg: string) {
    super(msg)
    Object.setPrototypeOf(this, RecorderError.prototype)
  }
}

export class QuotaExhaustedError extends RecorderError {
  constructor(msg: string) {
    super(msg)
    Object.setPrototypeOf(this, QuotaExhaustedError.prototype)
  }
}

export class InvalidRecorderStatus extends RecorderError {
  constructor(action: string, status: string) {
    super(`Recorder has invalid state to perform ${action} action: ${status}`)
    Object.setPrototypeOf(this, InvalidRecorderStatus.prototype)
  }
}
